import {
  Badge,
  Checkbox,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@@/ui/primitives';

interface PickListInputProps {
  required?: boolean;
  options: string[];
  multiple: boolean;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
}

export function PickListInput({
  required,
  options,
  multiple,
  value,
  onChange,
  disabled = false,
  label,
  placeholder
}: PickListInputProps) {
  if (multiple) {
    const selectedValues = (value || '').split(',').filter(Boolean);

    return (
      <div className='space-y-2'>
        <div className='flex items-center gap-2'>
          {label && <Label className='text-neutral-800 text-sm font-medium'>{label}</Label>}
          <Badge variant='outline' className='text-slate-800 border-slate-400 text-xs!'>
            Pick List
          </Badge>
        </div>
        {options.map((option) => {
          const isSelected = selectedValues.includes(option);

          return (
            <label key={option} className='flex items-center gap-2'>
              <Checkbox
                checked={isSelected}
                onCheckedChange={(checked) => {
                  let newValues: string[];
                  if (checked) {
                    newValues = [...selectedValues, option];
                  } else {
                    newValues = selectedValues.filter((v) => v !== option);
                  }
                  onChange(newValues.join(','));
                }}
                disabled={disabled}
              />
              <span className='text-sm'>{option}</span>
            </label>
          );
        })}
      </div>
    );
  }

  return (
    <div className='space-y-2'>
      <div className='flex items-center gap-2'>
        {label && <Label className='text-neutral-800 text-sm font-medium'>{label}</Label>}
        <Badge variant='outline' className='text-slate-800 border-slate-400 text-xs!'>
          Pick List
        </Badge>
      </div>
      <Select required={required} value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className='text-sm! font-medium! bg-white w-full'>
          <SelectValue placeholder={placeholder || 'Select option...'} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
